import { AUTH_ENDPOINTS } from "./auth/index"
import { USERS_ENDPOINTS } from "./users"
import { CALLREPORTS_ENDPOINTS } from "./callreports"
import { CALLSTATS_ENDPOINTS } from "./callstats"
import { CALL_REPORT_FILTERS_ENDPOINTS } from "./call-report-filters"
import { CLIENTS_ENDPOINTS } from "./clients"
import { REDIS_CACHE_ENDPOINTS } from "./redis-cache"
import { SIP_FRIENDS_ENDPOINTS } from "./sipfriends"
import { SIP_TRAFFIC_ENDPOINTS } from "./siptraffic"
import { THRESHOLDS_ENDPOINTS } from "./thresholds"
import { SIP_SERVERS_ENDPOINTS } from "./sip-servers"
import { TRANSSCRIPTION_ENDPOINTS } from "./transcription"
import { CALLS_ENDPOINTS } from "./calls"

export const CALL_STATS_ENDPOINTS = {
  auth: AUTH_ENDPOINTS,
  users: USERS_ENDPOINTS,
  callreports: CALLREPORTS_ENDPOINTS,
  transcription: TRANSSCRIPTION_ENDPOINTS,
  callstats: CALLSTATS_ENDPOINTS,
  call_report_filters: CALL_REPORT_FILTERS_ENDPOINTS,
  clients: CLIENTS_ENDPOINTS,
  calls: CALLS_ENDPOINTS,
  redis_cache: REDIS_CACHE_ENDPOINTS,
  sip_friends: SIP_FRIENDS_ENDPOINTS,
  siptraffic: SIP_TRAFFIC_ENDPOINTS,
  thresholds: THRESHOLDS_ENDPOINTS,
  sip_servers: SIP_SERVERS_ENDPOINTS,
}